<script>

export default {
  name: "ReportsMixin",
  props: {
    reportId: {
      type: [String, Number],
      default: null
    },
    reportInfo: {
      type: [Object],
      default: null
    }
  },
  data () {
    return {
      reportTypes: {
        'lgbtq': 'ЛГБТКИ+',
        'outreach': 'Аутрич',
        'casemanagement': 'КМ',
        'seminar': 'Семинар',
        'psych': 'Психолог',
        'lawyers': 'Юристы'
      },
    prevTestsResult:null}
  },
  computed: {
    productsRights () {
      return this.reportTypes[this.reportType]
    },
    productsListFiltered () {
      let res = this.productsList ? this.productsList.filter(p => {
        if ('producttype' in p && p.producttype !== null) return [3, 1].indexOf(p.producttype.id) > -1 &&
            (p.report_type.indexOf(this.productsRights) > -1)
      }) : []
      return res
    },
    productsListItems () {
      let items = this.productsListFiltered.map(p => ({'text':p.name,'additionalName':p.additional_name,'value':p.id,'name':p.name,'id':p.id, 'field_group':p.field_group}))
      this.productsListSelected = items.slice(0,15).map(p => p.value)
      return items
    },
    directionsListItems () {
      let items = this.directionsListCaseFiltered.map(p => ({'text':p.name,'additionalName':p.additional_name,'value':p.id,'name':p.name,'id':p.id}))
      this.directionsListSelected = items.slice(0,15).map(p => p.value)
      return items
    },
    testsListFiltered () {
      let items = this.testsList ? this.testsList.filter(p => {
        return (p.report_type.indexOf(this.productsRights) > -1)
      }) : []
      return items
    },
    testsListItems () {
      // let vm = this
      // //console.log(this.prevTestsResult, this.testsListFiltered)
      let items = this.testsListFiltered.map(p => ({'text':p.name,
                                                    'value':p.id,'tests_id':p.id,'name':p.name, 'id': p.id,
                                                    'is_tested':false,
                                                    'diseasetype':{'name':p.diseasetype.name,'id':p.diseasetype.id},
                                                    'result': {'is_positive':null,
                                                               'link_id': null,
                                                                'result':null,
                                                                 'result_prev':null
                                                               }
                                                      })
                                              )
                                                            // 'result_prev':vm.prevTestsResult && p.diseasetype ? vm.prevTestsResult[p.diseasetype.name] : false

      this.testsListSelected = items.slice(0,15).map(p => p.id)
      return items
    },
    consultListFiltered () {
      return this.consultingsList.filter(p => {
        return p.report_type.indexOf(this.productsRights) > -1
      })
    },
    directionsListCaseFiltered () {
      return this.directionsList.filter(p => {
        return(p.report_type.indexOf(this.productsRights) > -1)
      })
    },
    consultListItems () {
      let items = this.consultListFiltered.map(p => ({'text':p.name,'value':p.id,'name':p.name,'id':p.id,'field_type':p.field_type}))
      this.consultListSelected = items.map(p => p.value)
      return items
    },
    directionListCaseItems () {
      let items = this.directionsListCaseFiltered.map(p => ({'text':p.name,'value':p.id,'name':p.name,'id':p.id}))
      this.directionListSelected = items.slice(0,15).map(p => p.value)
      return items
    },
    customerGroupsListItems () {
      let items = this.customerGroupsList.map(p => ({'deleted':false,'name':p.name,'id':p.id}))
      this.customerGroupsListSelected = items.slice(0,15).map(p => p.value)
      return items
    },
    isOutreach () {
      return this.reportType === 'outreach'
    },
    reportType () {
      return this.$route.meta.reportType
    },
    reportTypeRoute () {
      let route = null
      switch (this.reportType) {
        case "outreach":
          route = 'ReportOutreach'
          break
        case "seminars":
          route = 'ReportSeminar'
          break
        case "casemanagement":
          route = 'ReportCase'
          break
        case "psych":
          route = 'ReportPsych'
          break
        case "lawyers":
          route = 'ReportLawyer'
          break
        default:
          route = 'ReportOutreach'
      }
      return route
    },
  },


}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/new/ReportsMixin.vue